import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchExpensesApi,
  addExpenseApi,
  updateExpenseApi,
  deleteExpenseApi,
} from "../services/ExpenseService";

// Fetch all expenses
export const fetchExpenses = createAsyncThunk(
  "expenses/fetchExpenses",
  async ({ searchText = "" }, { rejectWithValue }) => {
    try {
      const response = await fetchExpensesApi(searchText);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Add new expense
export const addExpense = createAsyncThunk(
  "expenses/addExpense",
  async (expenseData, { rejectWithValue }) => {
    try {
      const response = await addExpenseApi(expenseData);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Update expense
export const updateExpense = createAsyncThunk(
  "expenses/updateExpense",
  async (expenseData, { rejectWithValue }) => {
    try {
      const response = await updateExpenseApi(expenseData);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Delete expense
export const deleteExpense = createAsyncThunk(
  "expenses/deleteExpense",
  async (expenseId, { rejectWithValue }) => {
    try {
      const response = await deleteExpenseApi(expenseId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const expenseSlice = createSlice({
  name: "expenses",
  initialState: {
    expenses: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Expenses
      .addCase(fetchExpenses.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchExpenses.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        state.expenses = action.payload;
      })
      .addCase(fetchExpenses.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Expense
      .addCase(addExpense.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addExpense.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        state.expenses.push(action.payload);
      })
      .addCase(addExpense.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Expense
      .addCase(updateExpense.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateExpense.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        const index = state.expenses.findIndex(
          (expense) => expense.expense_id === action.payload.expense_id,
        );
        if (index !== -1) {
          state.expenses[index] = action.payload;
        }
      })
      .addCase(updateExpense.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Delete Expense
      .addCase(deleteExpense.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteExpense.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        state.expenses = state.expenses.filter(
          (expense) => expense.expense_id !== action.payload,
        );
      })
      .addCase(deleteExpense.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = expenseSlice.actions;
export default expenseSlice.reducer;
